module.exports = __webpack_public_path__ + "media/cycles-start@md-786a58ba00c531219711ae8f6d4319c3.jpg";